(function (app, ng) {
    app.component("agentDisclosure", {
        templateUrl: "/App/Dashboard/ConfigureAgentAccount/Disclosure/template.html",
        controller: agentDisclosureController,
        bindings: {
            onSave: "&",
            user: "<",
            agent: "<",
            //disclosures: "<"
        }
    });

    agentDisclosureController.$inject = ["$q", "disclosureApi", "agentApi", "$timeout"];

    function agentDisclosureController($q, disclosureApi, agentApi, $timeout) {
        var $ctrl = this;

        this.$onInit = function () {
            var promise = [];

            $ctrl.disclosures = [];
            $ctrl.UI = {};

            $ctrl.onSave({
                $func: upload
            });

            if ($ctrl.agent.DisclosureIds) {
                ng.forEach($ctrl.agent.DisclosureIds,
                    function (disclosureId) {
                        promise.push(agentApi.getAgentDisclosure($ctrl.agent.Id, disclosureId).then(function (response) {
                            $ctrl.disclosures.push(response);
                        }));
                    });
            } else $ctrl.agent.DisclosureIds = [];

            $q.all(promise).then(function () {
                if ($ctrl.disclosures.length)
                    $ctrl.UI.SelectedDisclosure = $ctrl.disclosures[0];
            });
        };

        function upload() {
            if (!$ctrl.agent) return $q.when();

            ng.forEach($ctrl.disclosures,
                function (disclosure, dkey) {
                    if (disclosure.Deleted) {

                        ng.forEach($ctrl.agent.DisclosureIds, function (disclosureId, adkey) {
                            if (disclosure.Disclosure.Id === disclosureId) {
                                $ctrl.agent.DisclosureIds.splice(adkey, 1);
                            }
                        });

                        $ctrl.disclosures.splice(dkey, 1);
                        $ctrl.UI.SelectedDisclosure = $ctrl.disclosures[0];
                    }
                });

            ng.forEach($ctrl.disclosures,
                function (d, dkey) {

                    if (d.Disclosure.TitleEdited !== null && d.Disclosure.TitleEdited) {
                        //update disclosure titles
                        disclosureApi.update(d.Disclosure.Id, d.Disclosure).then(
                            function (response) { console.log(response) });
                    }
                });

            if ($ctrl.disclosureFile) {
                var payload = new FormData();
                payload.append("disclosure", $ctrl.disclosureFile, $ctrl.disclosureFile.name);
                payload.append("title", $ctrl.newDisclosureTitle);
                return disclosureApi.add(payload).then(function (response) {

                    $ctrl.agent.DisclosureIds.push(response.Id);
                    return agentApi.updateDisclosure($ctrl.agent.DisclosureIds, $ctrl.agent.Id).then(function () {
                        $ctrl.disclosureFile = null;

                        return agentApi.getAgentDisclosure($ctrl.agent.Id, response.Id).then(function (data) {
                            $ctrl.disclosures.push(data);
                            $ctrl.UI.SelectedDisclosure = data;
                            return;
                        });
                    });
                });
            } else {
                return agentApi.updateDisclosure($ctrl.agent.DisclosureIds, $ctrl.agent.Id);
            }
        }
    }
})(window.app, window.angular); // jshint ignore:line